import { useContext, useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { HSPipelineContext } from "../../../App";
import { PlusIcon } from "@heroicons/react/24/solid";
import CardMyApplication from "./CardMyApplication";

function MyCandidaturesPage({ t, myCompletions, canCreateANewCompletion, type }) {
    const navigate = useNavigate();
    const hspipelines = useContext(HSPipelineContext);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setIsVisible(true), 250);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div className={isVisible ? "my-forms-visible max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" : "hidden"}>
            <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4 mb-2">
                <div>
                    <h1 className="text-[28px] font-bold text-gray-900">{t("Mes candidatures")}</h1>
                    <p className="text-gray-400 mt-1.5 text-sm">
                        {t("Suivez l'avancement de vos dossiers et finalisez votre inscription une fois admis.")}
                    </p>
                </div>
                {canCreateANewCompletion && (
                    <button
                        onClick={() => navigate("/newform")}
                        className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-5 py-2.5 text-sm font-semibold rounded-xl border transition-all duration-200 hover:shadow-md hover:scale-[1.03]"
                        style={{ borderColor: 'var(--primary-color)', color: 'var(--primary-color)' }}
                        onMouseEnter={e => { e.currentTarget.style.backgroundColor = 'var(--primary-color)'; e.currentTarget.style.color = '#fff'; }}
                        onMouseLeave={e => { e.currentTarget.style.backgroundColor = ''; e.currentTarget.style.color = 'var(--primary-color)'; }}
                    >
                        <PlusIcon className="h-4 w-4" />
                        {t("Nouvelle candidature")}
                    </button>
                )}
            </div>

            <div className="mt-6 flex flex-col gap-3">
                {[...myCompletions].sort((a, b) => {
                    // finished/submitted first, then by step descending
                    const stepA = a?.finishedInfo?.finished ? Infinity : (a.step ?? 0);
                    const stepB = b?.finishedInfo?.finished ? Infinity : (b.step ?? 0);
                    return stepB - stepA;
                }).map((completion, idx) => (
                    <CardMyApplication
                        key={idx}
                        t={t}
                        completion={completion}
                        hspipelines={hspipelines}
                        type={type}
                    />
                ))}
            </div>
        </div>
    );
}

export default withTranslation()(MyCandidaturesPage);
